import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JobSearchService } from 'src/app/core/services/http/maintenance/job-search.service';
import { AdvancedSeachFilteredJobsResult } from 'src/app/job/models/dashboard/advanced-search-filtered-jobs-result.model';
import { AdvancedSearchComponent } from 'src/app/shared/components/advanced-search/advanced-search.component';
import { AdvancedSearch } from 'src/app/shared/models/advanced-search.model';
import { MatPaginator } from '@angular/material/paginator';
@Component({
  selector: 'app-advanced-search-jobs',
  templateUrl: './advanced-search-jobs.component.html',
})
export class AdvancedSearchJobsComponent implements AfterViewInit {
  @ViewChild(AdvancedSearchComponent, { static: false }) advancedSearchComponent: AdvancedSearchComponent;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  selectedSortOption: string = 'PostedDate';
  selectedSortOrder: 'Ascending' | 'Descending' = 'Descending';

  constructor(
    private router: Router,
    private jobSearchService: JobSearchService,
    private route: ActivatedRoute
  ) {}

  public version: string = new Date().toString();
  public filteredJobList: AdvancedSeachFilteredJobsResult[] = null;
  public isLoad: boolean = false;
  public totalRowCount: string = '0';
  public pageIndex: number = 0;
  isFilterdJobListAvailable: boolean = this.filteredJobList ? true : false; 

  advanceSearch = AdvancedSearch.getInstance();
  
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.selectedSortOption = params['selectedSortOption'];
      this.selectedSortOrder = params['selectedSortOrder'];
    });

    if(!this.selectedSortOption)
      this.selectedSortOption = 'PostedDate';
    if(!this.selectedSortOrder)
      this.selectedSortOrder = 'Descending';
  }

  ngAfterViewInit(): void {
    if (this.advanceSearch.isApply) {
      let data = this.advancedSearchComponent.requestDto;
      data.jobNameOrNumber = this.advanceSearch.selectedJobIdentification;
      data.tradeIds = this.removeDuplicate(this.advanceSearch.tradeesChips)
        ?.map((s) => s.id)
        .toString()
        .trim();
      data.propertyIds = this.removeDuplicate(this.advanceSearch.propertyChips)
        ?.map((s) => s.id)
        .toString()
        .trim();
      data.types = this.removeDuplicate(this.advanceSearch.selectedJobType)
        ?.map((s) => s.id)
        .toString()
        .trim();
      data.jobStatus = this.removeDuplicate(this.advanceSearch.selectedStatus)
        ?.map((s) => s.id)
        .toString()
        .trim();

      data.urgencyTypeId = this.advanceSearch.selectedUrgency.id;
      data.serviceTypes = this.removeDuplicate(
        this.advanceSearch.serviceTypesChips
      )
        ?.map((s) => s.id)
        .toString()
        .trim();
      data.postedFromDate = this.advanceSearch.posted_Start != null ? new Date(new Date(this.advanceSearch.posted_Start).setHours(0, 0, 0, 0)).toUTCString():'';
      data.postedToDate = this.advanceSearch.posted_End != null ? new Date(new Date(this.advanceSearch.posted_End).setHours(23, 59, 59, 0)).toUTCString():'';
      data.dueFromDate = this.advanceSearch.deadLine_Start;
      data.dueToDate = this.advanceSearch.deadLine_end;
      data.pageNumber = this.advanceSearch.pageNumber;
      data.pageSize = this.advanceSearch.pageSize;
      data.isSnoozedJob = this.advanceSearch.isSnoozedJob;
      this.pageIndex = this.advanceSearch.pageNumber - 1;
      data.selectedTeamBusinessUserIds = this.advanceSearch.selectedTeamUsers
        ?.filter(user => user.businessUserId && user.businessUserId !== "ORGANIZATION_VIEW_ID")
        .map(user => user.businessUserId)
        .toString();
      data.sortColumn = this.selectedSortOption;
      data.sortDirection = this.selectedSortOrder;
      this.getData(data);
    }
  }

  jobDashBoard() {
    this.router.navigate(['/job']);
  }
  requestDtoChanged($event) {
    this.filteredJobList = null;
    setTimeout(() => (this.filteredJobList = $event), 100);
    this.totalRowCount = $event?.length > 0 ? $event[0].totalRowCount : '0';
    this.isLoad = true;
    this.isFilterdJobListAvailable = $event ? true : false;
  }
  pageChangeEvent(event) {
    var data = this.advancedSearchComponent.requestDto;
    data.pageNumber = event.pageIndex;
    if (event.previousPageIndex > event.pageIndex) {
      data.pageNumber = event.previousPageIndex;
    } else {
      data.pageNumber = event.pageIndex + 1;
    }
    if (event.pageIndex === 0) {
      data.pageNumber = 1;
    }
    this.advanceSearch.pageNumber = data.pageNumber;
    this.getData(data);
  }

  getData(data: any) {
    this.jobSearchService.getAdvancedSearchData(data).subscribe({
      next: (result) => {
        this.totalRowCount = result.length > 0 ? result[0].totalRowCount : '0';
        this.filteredJobList = result;
        this.isFilterdJobListAvailable = true;
        this.isLoad = true;
      },
      error: (error) => {},
    });
  }

  removeDuplicate(a: Array<{ id: number; text: string }>) {
    if (a.length > 1 && a.some((x) => x.text.includes('Any'))) {
      a = a.filter((r) => r.text.includes('Any'));
    }
    return a.filter(function (item, pos, self) {
      return self.indexOf(item) == pos;
    });
  }

  onNumberOfResultsPerPageChange(event: any) {
    if (event.isUserInput) {
      this.advancedSearchComponent.isApply = true;
      this.advanceSearch.pageSize = event.source.value;
      this.advanceSearch.scrolledTop = 0;
      if (this.filteredJobList) {
        var data = this.advancedSearchComponent.requestDto;
        data.pageSize = this.advanceSearch.pageSize;
        data.pageNumber = 1;
        this.advanceSearch.isApply = true;
        this.advanceSearch.pageNumber = 1;
        this.jobSearchService.getAdvancedSearchData(data).subscribe({
          next: (result) => {
            this.filteredJobList = result;
            this.isFilterdJobListAvailable = true;
            this.advancedSearchComponent.resultEmit(result);
            this.advancedSearchComponent.isApply = false;
          },
          error: (error) => {},
        });
      }
    }
  }

  onclickRow(row) {
   this.advanceSearch.scrolledTop = document.querySelector(".page-content-container").scrollTop;
    this.router.navigate(['/job/job-detail/', row.id], {
      state: { isFromAdvancedSearch: true, selectedSortOption: this.selectedSortOption, selectedSortOrder: this.selectedSortOrder },
    });
  }

  onSortChanged(event: { sortOption: string; sortOrder: 'Ascending' | 'Descending' }) {
    var data = this.advancedSearchComponent.requestDto;

    this.selectedSortOrder = event.sortOrder;

    switch(event.sortOption){
      case 'Job Title': {
        this.selectedSortOption = 'Name';
        break;
      }
      case 'Job ID':{
        this.selectedSortOption = 'JobNumber'
        break;
      }
      case 'Property Address':{
        this.selectedSortOption = 'Address'
        break;
      }
      case 'Status':{
        this.selectedSortOption = 'JobStatusDescription'
        break;
      }
      case 'Service Type':{
        this.selectedSortOption = 'ServiceType'
        break;
      }
      case 'Posted Date':{
        this.selectedSortOption = 'PostedDate'
        break;
      }
      case 'Service Provider':{
        this.selectedSortOption = 'ServiceProviderName'
        break;
      }
      case 'Property Manager':{
        this.selectedSortOption = 'AssignedPM'
        break;
      }
      case 'Deadline':{
        this.selectedSortOption = 'Deadline'
        break;
      }
    };
    data.sortColumn = this.selectedSortOption;
    data.sortDirection = this.selectedSortOrder == 'Ascending' ? 'ASC' : 'DESC';
    data.pageNumber = 1;   
    this.paginator.pageIndex = 0;
    this.paginator._changePageSize(this.paginator.pageSize);
  }
}
